<template>
    <div class="photo-card" @click="handleClick">
        <div class="photo-card__thumb">
            <app-image :src="thumbUrl" :ratio="ratio"/>
        </div>
        <div class="photo-card__content">
            <!-- 标题 -->
            <h2 class="photo-card__title">{{ data.title }}</h2>
            <!-- 描述 -->
            <p class="photo-card__description">{{data.description}}</p>
            <div class="photo-card__info">
                <span class="photo-card__author">{{ author.name }}</span>
                <span class="photo-card__break">•</span>
                <span class="photo-card__date">{{ publishDate }}</span>
                <span class="photo-card__break">•</span>
                <span class="photo-card__read">{{ views }} 次阅读</span>
            </div>
        
        </div>
    </div>
</template>

<script>
    import AppImage from '@components/AppImage'
    import {formatDate} from '@utils'
    import {DEFAULT_THUMB_URL} from '@config'
    
    export default {
        name: "PhotoCard",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },
        computed: {
            author() {
                const {data} = this
                return data.author || {}
            },
            // 发布日期
            publishDate() {
                const {data} = this
                const {publishDate} = data || {}
                if (publishDate) {
                    return formatDate(new Date(publishDate), 'yyyy年MM月dd日')
                }
                return '无'
            },
            thumbUrl() {
                const {data} = this
                const {thumbUrl} = data || {}
                return thumbUrl || DEFAULT_THUMB_URL
            },
            views() {
                const {data} = this
                const {views} = data || {}
                return views || 0
            },
            ratio() {
                const {data} = this
                const {ratio} = data || {}
                return ratio || '16:9'
            }
        },
        methods: {
            handleClick() {
                this.$emit('click', this.data)
            }
        },
        components: {
            AppImage
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";
    
    .photo-card {
        position: relative;
        padding: $paddingMD;
        margin-bottom: $paddingSP;
        border-radius: $radius;
        background-color: $componentBackgroundColor;
        background-color: var(--componentBackgroundColor);
        cursor: pointer;
        @include transition-colors;
        
        &:hover {
            background-color: $componentHighLightColor;
            background-color: var(--componentHighLightColor);
        }
        
        &__thumb {
            width: 100%;
            margin-bottom: $paddingMD;
            border-radius: $radius;
            overflow: hidden;
        }
        
        &__info {
            text-align: right;
            font-size: $fontSizeCommon;
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
        }
        
        &__break {
            margin: 0 $paddingBase;
        }
        
        &__author {
            font-weight: $fontWeightBold;
            color: $textColor;
            color: var(--textColor);
        }
        
        
        &__title {
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSizeMD;
            font-weight: $fontWeightBold;
            margin-bottom: $paddingMD;
            @include transition-colors;
            
            &:hover {
                color: $primaryColor;
                color: var(--primaryColor);
            }
        }
        
        &__description {
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
            font-size: $fontSize;
            margin-bottom: $paddingMD;
        }
    }
</style>